<template>
  <div class="content">
	<app-header></app-header>
	<div class="app">请登录电脑端完成认证，发布招聘</div>
	<div class = "toCertification">
		<div class="toCertificationCon">
			<p class="step"></p>
			<h2>{{adviceMsg}}<router-link  v-if="nowStatue == '0'" to="/identityReview" class = "toidentityReview">去认证单位身份</router-link></h2>
			<em>{{postMsg}}</em>			
			<p class="selectToDo"><span @click = "publickNew">发布新职位</span>
			<router-link to="/identityReview">单位主页设置</router-link>
			<router-link to="/index">科研人才网首页</router-link></p>
			<img src="../../assets/imgs/companyRegBg.png" alt="科研人才网-高校教师硕士博士科研招聘平台">
		</div>
	</div>
	<div class="recording clearfix" v-if="nowStatue == '2'">
		<div class="titles clearfix">       
			<span class="nis">发布招聘记录</span>
			<p class="fr">
				<i @click = "changeRecord" v-if = "comRecordingList.length > 0"><span class="icon iconfont">&#xe64f;</span>修改岗位</i>
				<i @click = "onOutRecord"  v-if = "comRecordingList.length > 0"><span class="icon iconfont">&#xe704;</span>上下线岗位</i>
				<i @click = "deleteRecord"  v-if = "comRecordingList.length > 0"><span class="icon iconfont">&#xe640;</span>删除岗位</i>
			</p>
		</div>
		<div class="recordingContent clearfix">
			<div class="recordingList fl" v-bind:class="{outlineClass:items.state == 0}" v-for = "items in comRecordingList" :key="items.id">
				<div class="outline" v-show = "items.status == 1"></div>
				<div class="changeRecording" v-show = "deleteFlag||changeFlag||onOutRecordFlag">
					<span @click = "changeDetail(items.recruitId)" v-show = "changeFlag">修改</span>
					<span @click = "outDetail(items.recruitId)" v-show = "onOutRecordFlag">下线</span>
					<span @click = "onDetail(items.recruitId)" v-show = "items.status == 1">上线</span>
					<span @click = "deleteDetail(items.recruitId)" v-show = "deleteFlag">删除</span>
				</div>
				<div @click = "positionsDetail(items)" class="recordingTop">
					<p class="positions-title clearfix">{{items.title}}
						<!-- <span class="fr"><span v-show = "items.state == 0" class="icon iconfont">&#xe65f;</span>浏览：{{items.view}}</span> -->
					</p>
					
					<!-- <p class="positions-detail clearfix" style="margin-top:10px;"><span><i style="color: #1787FB;">开始时间</i>：{{items.beginTime}}</span><span><i style="color: #1787FB;">结束时间</i>：{{items.endTime}}</span></p> -->
					<!-- <div class="abstracts"><i>摘要：</i>{{items.abstracts}}</div> -->
					<div class="abstracts"><i>所属专业：</i>{{items.major}}</div>
					<div class="abstracts"><i>所属分类：</i>{{items.categoryCode}}</div>
					<p class="positions-detail clearfix"><i class="fl" style="color: #1787FB;">创建时间：</i><span class="fl">{{items.createTime}}</span></p>
					<!-- <p class="positions-detail clearfix"><i class="fl" style="color: #1787FB;">地址：</i><span class="fl" style="width:310px">{{items.address}}</span></p> -->
					<!-- <h3><i class="fl">{{items.name}}</i><span class="fr">{{items.salaryLow}}k - {{items.salaryHigh}}k</span></h3>
					<p class="positions-detail clearfix"><span>工作经验：{{items.workYear}}</span><span>学历要求：{{items.edu}}</span></p>
					<p class="positions-detail clearfix"><span>工作性质：{{items.nature}}</span><span>所属部门：{{items.branch}}</span></p> -->
					<!-- <p class="positions-detail clearfix"><i class="fl">岗位职责：</i><span class="fl" v-html = "items.description"></span></p> -->
				</div> 
				<p class="resumeMsg"><span>已投递简历： {{items.submitNum}}</span><span>未阅读： {{items.submitNum-items.lookNum}}</span>
					<span @click = "views(items.recruitId)" class="checkOut">查看简历</span>
				</p>
			</div>
			<p v-if = "comRecordingList.length <=0" @click = "publickNew" style="cursor: pointer;">发布一个新职位，开启你的招聘之旅</p>
		</div>
		<div v-if = "totalPag > pageSize" style="text-align:center" class="page-bar">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 30, 50, 100]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalPag">
			</el-pagination>
			    <!--<ul class="clearfix">
			    		<li v-if="cur==1"><a class="banclick">首页</a></li>
			    		<li v-if="cur > 1"><a v-on:click="firstClick()">首页</a></li>
			        <li v-if="cur>1"><a v-on:click="cur--,pageClick()">上一页</a></li>
			        <li v-if="cur==1"><a class="banclick">上一页</a></li>
			        <li v-for="index in indexs"  v-bind:class="{ 'active': cur == index}" :key="index.id">
			            <a v-on:click="btnClick(index)">{{ index }}</a>
			        </li>
			        <li v-if="cur!=all"><a v-on:click="cur++,pageClick()">下一页</a></li>
			        <li v-if="cur == all"><a class="banclick">下一页</a></li>
			        <li  v-if="cur!=all"><a v-on:click="endClick()">尾页</a></li>
			        <li v-if="cur == all"><a class="banclick">尾页</a></li>
			        <li><a>共<i>{{all}}</i>页</a></li>
			    </ul> -->
			</div>
	</div>
	<app-footer></app-footer>
  </div>
</template>




<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
  name: 'companyCertification',
  components: {AppFooter,AppHeader },
    data () {
    	return {
    		userId:'', //userId
    		nowStatue:'0',//是否通过审核
    		adviceMsg:'招聘者身份审核已通过',
    		companyId:'',//公司id
    		comRecordingList:'',//招聘记录列表
    		deleteFlag:false,
			onOutRecordFlag:false,
    		changeFlag:false,
    		pageSize:9,
			postMsg:'发布一个新职位，开启你的招聘之旅',
            currentPage:1,
			totalPag:10,
			majorList:{
				"zhe_xue":"哲学",
				"jing_ji_xue":"经济学",
				"fa_xue":"法学",
				"jiao_yu_xue":"教育学",
				"wen_xue":"文学",
				"li_shi_xue":"历史学",
				"li_xue":"理学",
				"gong_xue":"工学",
				"nong_xue":"农学",
				"yi_xue":"医学",
				"guan_li_xue":"管理学",
				"yi_shu_xue": "艺术学",
				"qi_ta":"其他"
			},
			options: {
				"gao_xiao":'高等院校',
				"pu_tong_ben_ke":'普通本科',
				"gao_zhi_yuan_xiao":'高职院校',
				"gao_deng_jiao_xue_ke_yan":'教学科研',
				"jiao_fu_gang_wei":'教辅岗位',
				"ke_yan_yuan_suo":'科研院所',
				"ke_yan_jiao_xue_ke_yan":'教学科研',
				"xing_zheng_gang_wei":'行政岗位',
				"yi_yao_wei_sheng":'医药卫生',
				"zhi_ming_qi_ye":'知名企业',
				"shi_ye_dan_wei":'事业单位',
				"yin_cai_zhuan_xiang":'引才专项',
				"shi_ye_dan_wei_zhao_pin":'事业单位招聘',
				"shuo_bo_re_zhao":'硕博热招',
				"shuo_shi_zhao_pin":'硕士招聘',
				"bo_shi_zhao_ping":'博士招聘',
				"zhi_ye_qing_bao":'职业情报',
				"bo_shi_hou":'博后进站',
				"gao_xiao_bo_hou":'高校博后',
				"ke_yan_yuan_suo_bo_hou":'科研院所博后',
				"qi_ye_bo_hou":'企业',
				"guo_wai_bo_hou":'国外博后',
				"zhuan_jia_te_ping":'高端职位',
				"zhong_gao_ceng_guan_li":'中高层管理人才',
				"te_ping_zhuan_jia":'博后进站',
				"xue_shu_dai_tou_ren":'学术带头人',
				"guo_wai_xiang_mu":'国外项目',
				"bo_shi_zhao_sheng":'博士招生',
				"bo_hou_huo_yan_jiu_yuan_zhao_ping":'博后/研究生招聘',
				"fang_wen_xue_zhe":'访问学者',
				"hai_gui_yin_jin":'海归引进',
				"shuo_shi_yin_jin":'硕士引进',
				"bo_shi_yin_jin":"博士引进",
				"ke_chuang_zhuan_qu":'科创专区',
				// "she_hui_jian_zhi":'社会兼职',
			},
    	}
	},

    created:function () {
		
	},
	mounted:function(){
		this.getCompanyInfo();//获取userId
		// this.systemLink();//获取友情链接
		// this.verifiedCompany();//查询审核状态
		// this.getPostList();
	},
	methods:{
		// verifiedCompany:function(){//查询审核状态
		// 	let _self = this;
		// 	let urls = 'https://www.uncle119.com/api/verified/hunter/'+_self.userId;
		// 	_self.$http.get(urls).then(
		// 		function(response) {
		// 			if(response.body.code == 200){
		// 				_self.nowStatue = response.body.data.verified;
		// 				_self.companyId = response.body.data.companyId;
		// 				if(_self.nowStatue === 2){
		// 					_self.adviceMsg = "正在审核中,请耐心等待!"
		// 				}else if(response.body.data.verified === 0){
		// 					_self.adviceMsg = response.body.data.rejectReason;
		// 				}else if(this.nowStatue === 1){
		// 					this.companyPostJob();
		// 				}
		// 			}else{
		// 				_self.$layer.msg(response.body.msg);
		// 			}
		// 		},
		// 		function(response) {
		// 			_self.$layer.msg(response.body.msg);	            
		// 		}
		// 		)
		// },
		getCompanyInfo:function(){
			let _self = this;
			let userCoookie = this.getCookie("session_token");
			if(userCoookie == null || userCoookie == ""){
				this.$router.push({ path:'/login',query:{loginFlag:false}});
				return false;
			}
			_self.userName = localStorage.getItem('_userName');
			let myreg = /^1\d{10}$/;
			if(myreg.test(_self.userName) || _self.userName == ""){
				// this.flags = false;
				localStorage.setItem('_userName',"");
				this.$router.push({path:"/login"})
				return false;
			}
			postWithJson('front/user/getCompanyInfo',{email:_self.userName}).then(
				function(response) {
					if(response.data.status){
						let resData = response.data.data;
						_self.companyId = resData.id;
						_self.nowStatue = resData.verified;
						_self.getPostList();
						if(_self.nowStatue == 0){
							_self.adviceMsg = '未认证,请去设置单位主页!'
						}else if(_self.nowStatue == 1){
							_self.adviceMsg = "认证中,请耐心等待!"
						}else if(_self.nowStatue == 3){
							_self.adviceMsg = "认证拒绝,请重新设置单位主页!"
						}
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					console.log(response);
					// _self.$message({
					// 		message: "请重试",
					// 		type: 'error'
					// 	});        
				}
			)	
			if(_self.companyId != "" &&  _self.companyId != null){
				this.$router.push({ path:'/login'})
			}				
		},
  	
		getPostList:function(){ //获取已经发布信息
			let _self = this;
			let url = '/front/recruit/queryOnOrDown?pageNum='+_self.currentPage+'&pageSize=9'
			postWithJson(url,
			{city:"",province:"",dictCode:'',companyId:_self.companyId,keyWord:''}).then(
				function(response) {
					// _self.comRecordingList = response.data.data;
					let comRecordingList = response.data.data;
					comRecordingList.map(function(val,index,arr){
						console.log(val);
						if(val.major){
							// this.changeFlag = false;
							// this.onOutRecordFlag = false;
							let major = val.major.split(",");
							let categoryCode = val.categoryCode.split(",");
							let majorVal = "";
							major.map(function(val,index,){
								majorVal += _self.majorList[val]+","
							})
							let categoryVale = "";
							categoryCode.map(function(val,index,arr){
								categoryVale += _self.options[val]+','
							})
							val.major = majorVal.slice(0,majorVal.length-1);
							val.categoryCode = categoryVale.slice(0,categoryVale.length-1);
						}
					})
					_self.comRecordingList = comRecordingList;
					_self.totalPag = response.data.total
				},
				function(response) {
					_self.$message({
						message: response.data.message,
						type: 'error'
					});	            
				}
			)
		},
		changeRecord:function(){
			this.changeFlag = !this.changeFlag;
			this.deleteFlag = false;
			this.onOutRecordFlag = false;
		},
		onOutRecord:function(){
			this.onOutRecordFlag = !this.onOutRecordFlag;
			this.changeFlag = false;
			this.deleteFlag = false;
			console.log(this.onOutRecordFlag)
		},
		deleteRecord:function(){
			this.deleteFlag = !this.deleteFlag;
			this.changeFlag = false;
			this.onOutRecordFlag = false;
		},
		publickNew:function(){
			let _self = this;
			if(_self.nowStatue == undefined || _self.nowStatue ==  '0'){
				_self.$message({
					message: "未认证,请去设置单位主页!",
					type: 'error'
				});		
				return false;
			}else if(_self.nowStatue == '1'){
				_self.$message({
					message: "认证中,请耐心等待!",
					type: 'error'
				});	
				return false;
			}else if(_self.nowStatue == '3'){
				_self.$message({
					message: "认证拒绝,请重新设置单位主页!",
					type: 'error'
				});	
				return false;
			}
			localStorage.setItem('_jobUpdateId', "");
			_self.$router.push({ path:'/postJob'})
		},
		//下线
		outDetail:function(theId){
			let _self = this;
			postWithJson('/front/recruit/onOrDown',{recruitId:theId+"",status:1}).then(
				function(response) {
					if(response.data.status){
						_self.$message({
							message: "已下线",
							type: 'success'
						});
						_self.getPostList();
						_self.deleteFlag  = false;
						_self.changeFlag  = false;
						_self.onOutRecordFlag  = false;
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					console.log(response);       
				}
			)
		},
		//上线
		onDetail:function(theId){
			let _self = this;
			postWithJson('/front/recruit/onOrDown',{recruitId:theId+"",status:0}).then(
				function(response) {
					if(response.data.status){
						_self.$message({
							message: "已上线",
							type: 'success'
						});
						_self.deleteFlag  = false;
						_self.changeFlag  = false;
						_self.onOutRecordFlag  = false;
						_self.getPostList();
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					console.log(response);       
				}
			)
		},
		//修改招聘
		changeDetail:function(theId){
			let jobUpdateId = theId;
			localStorage.setItem('_jobUpdateId', jobUpdateId);
			this.$router.push({ path:'/postJob'});
		},
		//删除简历   暂无接口
		deleteDetail:function(theId){
			let _self = this;
			postWithJson('front/recruit/deleteRecruit',
			{ids:theId,}).then(
				function(response) {
					if(response.data.status){
						_self.$message({
							message: "删除成功！",
							type: 'success'
						});
						_self.getPostList();
						_self.deleteFlag  = false;
						_self.changeFlag  = false;
						_self.onOutRecordFlag  = false;
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
						message: response.data.message,
						type: 'error'
					});	            
				}
			)
			
		},
		positionsDetail:function(items){
			// if(items.state == 0){
			// 		this.$layer.msg("改条职位已下线");
			// 		return false;
			// }
			// this.$router.push({
			// 		path:'/comJobDetail',
			// 		query:{jobId:items.id}
			// });  		
		},
		views:function(jobId){
			let _self = this;
			// sessionStorage.setItem('_jobId',jobId);
			// sessionStorage.setItem('_companyId',_self.companyId);
			
			this.$router.push({path:'/preview',query:{jobId:jobId}});
		},
		// //分页
		handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.getPostList();
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPostList();
            // console.log(`当前页: ${val}`);
        },
	},  
	
	computed: {  
  	}, 
	
}
</script>

<style  lang = "less"  scoped="scoped">
.app{
	text-align: center;
	color: #333;
	display: none;
}
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
	border-radius: 3px;
    background-color: #c1c1c1;
}
.page-bar{
    margin:40px 0;
}
.page-bar ul{
	text-align: center;
}
.page-bar ul,li{
    margin: 0px;
    padding: 0px;
}
.page-bar li{
		display: inline-block;
    list-style: none;
    margin: 0 4px;
}
.page-bar li:first-child>a {
   margin-left: 0px
}
.page-bar a{
    border: 1px solid #ddd;
    text-decoration: none;
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #848484;
    cursor: pointer
}
.page-bar a:hover{
    background-color: #eee;
}
.page-bar a.banclick{
    cursor:not-allowed;
}
.page-bar .active a{
    color: #fff;
    cursor: default;
    background-color: #1787FB;
    border-color: #1787FB;
}
.page-bar i{
    font-style:normal;
    color: #1787FB;
    margin: 0px 4px;
    font-size: 12px;
}
.content{
	width: 100%;
	min-height: 870px;
	position: relative;
	background-color: #F4F8FF;
	.navs{
		background-color: white;
	}
	.header-right{
		height: 62px;
		line-height: 62px;	
		.head{
			width: 44px;
			height: 44px;
			border-radius: 50%;
			margin-top: 11px;
		}
		.header-msg{
			height: 44px;
			line-height: 20px;
			font-size: 12px;
			margin: 11px 12px 0;
			span{
				display: inline-block;
				height: 20px;
				line-height: 20px;
				margin: 0;
				color: #1787FB;
				width: 26px;
			}
		}
		
	}
	
	.toCertification{
		width: 100%;
		height: 520px;
		/* background: url(../../assets/images/certificationbg.png) no-repeat center center; */
		.toCertificationCon{
			width: 1200px;
			margin: 0 auto;
			padding-top:170px;
			position:relative;
			img{
				position: absolute;
				top: 120px;
				right: 0;
			}
			.toidentityReview{
				font-size: 20px;
				color: #6495ED;
				text-decoration: underline;
				font-weight: normal;
				margin-left: 20px;
				padding: 5px;
				box-sizing: border-box;
			}
			.step{
				width: 625px;
				height: 41px;
				line-height: 41px;
				position: relative;
				z-index: 9;
				background: url(../../assets/imgs/companyStep.png) no-repeat center center;
				color: white;
				span{
					display: inline-block;
					width: 200px;
					text-align: center;
				}
			}
			h2{
				font-size: 30px;
				color: #444;
				margin-top: 36px;
			}
			em{
				font-style: normal;
				font-size: 16px;
				color: #444;
				display: inline-block;
				height: 50px;
				line-height: 50px;
			}
			.selectToDo{
				span{
					display: inline-block;
					width: 160px;
					height: 52px;
					line-height: 52px;
					font-size: 18px;
					box-sizing: border-box;
					border: 2px solid #1787FB;
					text-align: center;
					margin-right: 10px;
					color: #444;
					cursor: pointer;
				}
				a{
					display: inline-block;
					width: 160px;
					height: 52px;
					line-height: 52px;
					font-size: 18px;
					box-sizing: border-box;
					border: 2px solid #1787FB;
					text-align: center;
					margin-right: 10px;
					color: #1787FB;
					cursor: pointer;
					background-color: white;
				}
				span:first-child{
					color: white;
					background-color: #1787FB;
				}
			}
		}
	}
	
	.recording{
		width: 1200px;
		margin: 30px auto 40px;
		.titles{
			height: 52px;
			line-height: 52px;
			box-sizing: border-box;
			margin-bottom: 10px;
			border-bottom:  1px solid #d4dae4;
			.nis{
				display: inline-block;
				width: 100px;
				height: 37px;
				line-height: 37px;
				text-align: center;
				border-bottom:  3px solid #1787FB;
				box-sizing: border-box;
				margin-top: 16px;
				font-size: 16px;
				font-weight: bold;
			}
			p{
				height: 52px;
				line-height: 52px;
				i{
					display: inline-block;
					font-style: normal;
					padding: 0 4px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					border: 2px solid #1787FB;
					cursor: pointer;
					font-size: 12px;
				}
				i:hover{
					background-color: #1787FB;
					color: white;
				}
			}
		}
		.recordingContent{
			.recordingList{
				width: 388px;
				height: 220px;
				border: 1px solid #d4dae4;
				overflow: hidden;
				box-sizing: border-box;
				background-color: white;
				position: relative;
				margin: 24px 0 0 18px;
				padding-bottom: 20px;
				.changeRecording{
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 9;
					background-color: rgba(0,0,0,0.3);
					span{
						display: inline-block;
						width: 70px;
						text-align: center;
						height: 40px;
						line-height: 40px;
						background-color: #1787FB;
						color: white;
						cursor: pointer;
						position: absolute;
						letter-spacing: 4px;
						top: 50%;
						left: 50%;
						margin-top: -20px;
						margin-left: -35px;
					}
				}
				.outline{
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					z-index: 8;
					background-color: rgba(0,0,0,0.2);
				}
				i{
					font-style: normal;
				}
				.recordingTop{
					padding: 12PX;
					cursor: pointer;
					.positions-title{
						height: 40px;
						line-height: 40px;
						border-bottom: 1px dashed #D4DAE4;
						font-size: 16px;
						color: #444;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						.icon{
							color: #1787FB;
							margin-right: 8px;
						}
						
					}
					.abstracts{
						color:#999;
						font-size: 14px;
						height: 42px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						line-height: 21px;
						i{
							color: #1787FB;
						}
					}
				}
				h3{
					height: 48px;
					line-height: 48px;
					font-size: 16px;
					i{
						color: #444;
					}
					span{
						color: #1787FB;
					}
				}
				.positions-detail{
					color: #878787;
					font-size: 14px;
					/* border-bottom: 1px dashed #d4dae4;
					padding: 20px 0; */
					span{
						display: inline-block;
						width: 50%;
					}
				}
				.resumeMsg{
					margin-top: 15px;
					height: 50px;
					line-height: 50px;
					background-color: #8f8f8f;
					color: white;
					position: absolute;
					bottom: 0;
					left: 0;
					right: 0;
					text-align: center;
					span{
						margin: 0 10px;
					}
					.checkOut{
						display: inline-block;
						width: 70px;
						height: 28px;
						line-height: 26px;
						box-sizing: border-box;
						border: 2px solid #1787FB;
						background-color: white;
						color: #444;
						margin-top: 10px;
						cursor: pointer;
						font-size: 12px;
					}
				}
			}
			.recordingList:hover{
				border-color: #1787FB;
				box-shadow: 0 0 16px #aaa;
			}
			.recordingList:nth-child(3n+1){
				margin-left: 0;
			}
		}
	}
	
	.links{
		margin: 20px auto 0;
		background-color: #fcfcef;
		padding-top: 30px;
		.titles{
			width: 1200px;
			height: 38px;
			line-height: 38px;
			box-sizing: border-box;
			margin:0 auto 20px;
			border-bottom:  1px solid #d4dae4;
			span{
				display: inline-block;
				width: 100px;
				height: 37px;
				text-align: center;
				border-bottom:  2px solid #1787FB;
				box-sizing: border-box;
			}
		}
		.external-link-content{
			width: 1200px;
			margin: 0 auto;
			.external-link{
				width: 1100px;
				margin-bottom: 20px;
				height: 22px;
				overflow: hidden;
				a{
					display: inline-block;
					font-size: 14px;
					color: #444;
					margin-right: 16px;
					height: 20px;
					line-height: 20px;
					white-space: nowrap;
				}
			}
			.showmoreLink{
				height: 100%;
			}
			.more-link{
				width: 80px;
				color: #878787;
				font-size: 14px;
				cursor: pointer;
			}
		}
	}	
}
@media all and (max-width: 768px) {
    .toCertification{
		display: none
	}
	.app{
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/companyRegister/companyCertification.vue